import i18n from '@/i18n';

export const USERNAME_RULES = [
  // phone # regex from https://stackoverflow.com/a/16699507/834393
  // email regex from https://stackoverflow.com/a/201378/834393
  v => (/((\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4})/.test(v) ||
    // eslint-disable-next-line no-control-regex
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(v))
    || "Must be an email or phone number"
];

export const PASSWORD_RULES = [v => (v.length >= 8) || i18n.t('login.createAccount.passwordLengthAtLeast')];
export const PASSWORD_REPEAT_RULES = (newPassword) => [v => (v == newPassword) || i18n.t('login.createAccount.passwordRepeatNotSame')];

export const HELP_PHONE_NUMBER = "+254 740 524 629";
export const HELP_EMAIL = "support@ekitabu.com";
export const SUPPORT_URL = "https://support.ekitabu.com/shophelp/";
export const PRIVACY_POLICY_URL = "https://www.ekitabu.com/privacy-policy";
export const TERMS_OF_SERVICE_URL = "https://www.ekitabu.com/terms-of-service";
export const WHATS_APP_LINK = "https://wa.me/254740524629";

export const PRODUCTION_DOMAIN = "https://shop.ekitabu.com";
export const SITE_NAME = "eKitabu";
export const DEFAULT_OG_IMAGE = `${PRODUCTION_DOMAIN}/android-chrome-512x512.png`;
export const META_DESCRIPTION_MAX_LENGTH = 160;

// UI languages - limited to what we have translation files for
export const languages = [
  { code: "eng", name: "English" },
  { code: "kin", name: "Kinyarwanda" },
  { code: "swa", name: "Kiswahili" },
  { code: "nya", name: "Chichewa" },
];

// Book languages - all languages books can be written in
export const bookLanguages = [
  { code: "eng", name: "English" },
  { code: "swa", name: "Kiswahili" },
  { code: "kin", name: "Kinyarwanda" },
  { code: "tum", name: "Tumbuka" },
  { code: "nya", name: "Chichewa" },
  { code: "kik", name: "Gikuyu" },
  { code: "amh", name: "Amharic" },
  { code: "fra", name: "French" },
  { code: "deu", name: "German" },
];

export const KENYA_ALPHA_3 = "KEN";
export const RWANDA_ALPHA_3 = "RWA";
export const MALAWI_ALPHA_3 = "MWI";

export const supportedCountries = [
  { alpha2: "KE", alpha3: KENYA_ALPHA_3, currencyCode: "KES", name: "Kenya" },
  { alpha2: "RW", alpha3: RWANDA_ALPHA_3, currencyCode: "RWF", name: "Rwanda" },
  { alpha2: "MW", alpha3: MALAWI_ALPHA_3, currencyCode: "MWK", name: "Malawi" },
];

export const DEFAULT_TAX_REGION = "KEN";
export const DEFAULT_CURRENCY = "KES";
export const NOT_SUPPORTED_CURRENCY = "USD";

export const ROUND_TO_INT_CURRENCIES = ["KES", "RWF", "MWK"];

export const DEFAULT_PAGE_SIZE = 20;

export const USER_ROLES = {
  ADMIN: "ROLE_ADMIN",
  USER: "ROLE_USER",
  CHECKER: "ROLE_CHECKER",
  B2B: "B2B_CUSTOMER"
}

export const COUPON_RESTRICTIONS = Object.freeze({
  NONE: "NONE",
  BOOK: "BOOK",
  BOOKS: "BOOKS",
  PUBLISHER: "PUBLISHER",
  TAG: "TAG"
});

export const LOGIN_PROVIDERS = [
  "google",
];

export const PAYMENT_TYPES = Object.freeze({
  mpesa: "mpesa",
  creditCard: "creditCard",
  rwf: "rwf",
});

export const PAYMENT_PROVIDERS = Object.freeze({
  safaricom: "Safaricom MPESA",
  dpo: "DPO",
  mtn: "MTN",
  cash: "Cash",
  paybill: "Paybill",
  bankTransfer: "Bank Transfer",
  pdq: "PDQ",
  wholesale: "Wholesale Payment"
});

export const OFFLINE_PAYMENT_METHODS = Object.freeze({
  cash: "cash",
  paybill: "paybill",
  bankTransfer: "bank_transfer",
  pdq: "pdq",
});

export const FORMATS = Object.freeze({
  pdf: "application/pdf+lcp",
  epub: "application/epub+zip",
  print: "print",
  audio: "application/lpf+zip",
  digital: "digital"
});

export const FROM_ROUTES = Object.freeze({
  event: "eventOverview",
  customer: "customer",
  orderReport: "orderReport"
});

export const AUDIO_APP_LINK = "myapp://shop.ekitabu.com/mybookshelf";
export const AUDIO_APP_STORE_LINK = "https://play.google.com/store/apps/details?id=com.ekitabu.audio";
export const AUDIO_APP_STORE_LINK_IOS = "https://apps.apple.com/us/app/on-ekitabu/id6479268402";

export const GRADIENT_DEFAULTS = Object.freeze({
  directionDegrees: -90,
  startPercent: 0,
  endPercent: 100,
});

export const RELEASE_TYPES = Object.freeze({
  LISTED: 'listed',
  SCHEDULED: 'scheduled',
  UNLISTED: 'unlisted'
});

export const MAX_PRICE = 1000000;

// File size limits
export const FILE_SIZE_LIMITS = Object.freeze({
  PRODUCT_UPLOAD: 2 * 1024 * 1024 * 1024, // 2GB
  COVER_ART_UPLOAD: 8 * 1024 * 1024 - 1, // Slightly below 8MB to account for potential +1 errors
});
